import * as React from 'react';

interface Props {
  handleCsv: Function;
}

const buttons = (props: Props) => {
  return (
    <div className="level">
      <p className="level-item">
        <button
          className="button is-info is-outlined"
          onClick={e => props.handleCsv()}
        >
          <span className="icon">
            <i className="fas fa-file-download" />
          </span>
          <span>CSV Download</span>
        </button>
      </p>
    </div>
  );
};

export default buttons;



// WEBPACK FOOTER //
// ./src/components/Buttons.tsx